import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-100 py-8 mt-auto" data-id="element-13">
      <div className="container mx-auto px-4" data-id="element-14">
        <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-15">
          <div className="mb-6 md:mb-0" data-id="element-16">
            <h3 className="font-bold text-lg mb-2" data-id="element-17">ClearNail</h3>
            <p className="text-sm text-gray-600 max-w-xs" data-id="element-18">
              Your trusted partner for health and wellness products.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8" data-id="element-19">
            <div data-id="element-20">
              <h4 className="font-semibold mb-3" data-id="element-21">Company</h4>
              <ul className="space-y-2 text-sm" data-id="element-22">
                <li data-id="element-23">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-24">
                    About Us
                  </Link>
                </li>
                <li data-id="element-25">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-26">
                    Careers
                  </Link>
                </li>
                <li data-id="element-27">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-28">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-29">
              <h4 className="font-semibold mb-3" data-id="element-30">Support</h4>
              <ul className="space-y-2 text-sm" data-id="element-31">
                <li data-id="element-32">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-33">
                    FAQ
                  </Link>
                </li>
                <li data-id="element-34">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-35">
                    Shipping
                  </Link>
                </li>
                <li data-id="element-36">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-37">
                    Returns
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="text-sm text-gray-600 pt-4 border-t border-gray-200" data-id="element-38">
          <p data-id="element-39">© 2023 ClearNail. All rights reserved.</p>
          <div className="flex space-x-4 mt-2" data-id="element-40">
            <Link to="#" className="hover:text-[#0D9488]" data-id="element-41">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-[#0D9488]" data-id="element-42">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};